/**
 * Token store.
 *
 * Access token — in-memory only (short-lived, never persisted to storage).
 * Refresh token — persisted to localStorage so sessions survive page reloads.
 *   The refresh token alone cannot access APIs; it can only be exchanged for
 *   a short-lived access token via /v1/auth/refresh with token rotation.
 */

const REFRESH_TOKEN_KEY = "hyreese_rt";

let accessToken: string | null = null;

function getPersistedRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
}

function setPersistedRefreshToken(token: string | null) {
  try {
    if (token) {
      localStorage.setItem(REFRESH_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
  } catch {
    // Storage unavailable (private browsing, quota exceeded) — silent fallback
  }
}

export const tokenStore = {
  getAccessToken: () => accessToken,
  setAccessToken: (token: string | null) => {
    accessToken = token;
  },

  getRefreshToken: () => getPersistedRefreshToken(),
  setRefreshToken: (token: string | null) => {
    setPersistedRefreshToken(token);
  },

  clear: () => {
    accessToken = null;
    setPersistedRefreshToken(null);
  },
};
